import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="cta-section" className="py-12 md:py-16 lg:py-20 bg-[#F8FAFB] relative overflow-hidden">
      {/* Background pattern - dots */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle, #213F60 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      <div className="relative max-w-[800px] mx-auto px-4 md:px-8">
        <div className="text-center">
          {/* Main Heading */}
          <div className={`mb-4 md:mb-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#213F60] leading-tight px-4">
              Bắt đầu xây dựng DevSecOps đúng cách cho doanh nghiệp của bạn
            </h2>
          </div>

          {/* Sub-heading */}
          <div className={`mb-6 md:mb-8 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <p className="text-base md:text-lg text-[#495057] leading-relaxed px-4">
              Bắt đầu hành trình chuyển đổi số ngay hôm nay để không bỏ lỡ lợi thế cạnh tranh.
            </p>
          </div>

          {/* CTA Button */}
          <div className={`mb-6 transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <Link
              to="/lien-he"
              className="inline-block px-8 md:px-12 py-3 md:py-4 bg-[#20C997] text-white text-base md:text-lg font-bold rounded-lg shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-300 cursor-pointer"
              style={{
                boxShadow: '0 4px 20px rgba(32, 201, 151, 0.2)'
              }}
            >
              Đăng ký tư vấn miễn phí
            </Link>
          </div>

          {/* Trust Element */}
          <div className={`transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <p className="text-xs md:text-sm text-[#6C757D] flex items-center justify-center gap-2 px-4">
              <i className="ri-checkbox-circle-fill text-[#20C997]"></i>
              Hỗ trợ kỹ thuật 24/7 sau khi triển khai
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
